import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Router } from '@angular/router';
import { JsonPipe } from '@angular/common';
import { urls } from '../urls';
import { log } from 'console';

@Component({
  selector: 'app-countryselection',
  templateUrl: './countryselection.component.html',
  styleUrls: ['./countryselection.component.scss']
})
export class CountryselectionComponent implements OnInit {
  countryfilter:boolean;
  countryList:any[] =[
    {
    "countryCode": 356,
    "countryName": "India"
    },
    {
      "countryCode": 784,
      "countryName": "Uae"
    },
    {
      "countryCode": 840,
      "countryName": "Usa"
      },
];
  country:any;
  // countryCode: string;
  // countryName: string;
  businesCodeMap:Map<any, any> = new Map<any,any>();
  businessList: Array<any>=[];
  businessNameList:Array<string>=[];
  businessNameListOnUI:Array<string>=[];
  businessNameListOnUIUSA: string[];
  businessNameListOnUIUAE: string[];
  businessNameListOnUIIndia: string[];
  rootCategory:string;
  parentBusinessCode:string;
  constructor(private dataService: DataService, private router: Router) {

  }
  selectCountry(country) {
    // this.dataService.setSelectedCountryName(country.name)
    // this.dataService.setSelectedCountryCode(country.code)

    this.dataService.setSelectedCountryCode(country['countryCode'])
    this.country = country['countryCode'];
    this.dataService.setSelectedCountryName(country['countryName'])

    // this.dataService.eventTracker("CIS-PORTAL","Login",JSON.stringify(country),"/login");
    // this.router.navigateByUrl('/category-discovery');
  }

  skipBusinessOption(){
    this.countryfilter = true;  
    this.businessList=[];
    this.businessNameList=[]
    this.router.navigateByUrl('/category-discovery');
  }

  selectBusiness(code){
    this.dataService.setSelectedBusinessDisplayName(code);

    for (const [key, value] of Object.entries(this.businesCodeMap)) { 
      if( key==this.country){
          this.businessList = value;
          
          for (var i=0; i < this.businessList.length ; ++i){
            if(this.businessList[i]['businessDisplayName']==code){
              this.dataService.setSelectedParentBusinessCode(this.businessList[i]['businessCode']);

            }
          
          }

      }
    }
    this.countryfilter = true;  
    this.businessList=[];
    this.businessNameList=[]
    this.router.navigateByUrl('/category-discovery');
  }
  
  ngOnInit() {
    
    this.dataService.setCountryList(this.countryList)

    let url = urls.businessDetails;

    this.dataService.callRestful('GET', url, null, null, null, null).subscribe(this.processBusniessList.bind(this));
    this.dataService.offSpinner();

    if(this.dataService.getToken() && null!=this.dataService.getSelectedCountryCode() && null!=this.dataService.getSelectedBusinessDisplayName()){
      this.countryfilter =true;
      this.router.navigateByUrl('/category-discovery')
    }
    else{
      
      if(this.dataService.getToken() && null!=this.dataService.getCountryList() && this.dataService.getCountryList().length>0){
        this.countryList = this.dataService.getCountryList();
        
      }

    // if (this.dataService.getToken() && null != this.dataService.getSelectedCountryCode()) {
    //   this.dataService.setSelectedCountryName(this.countryList[0]['name'])
    //   this.dataService.setSelectedCountryCode(this.countryList[0]['code'])

    // } else {
    //   this.countryList = [{"name":'INDIA',"code":"356"},{"name":'UAE',"code":"784"},{"name":'USA',"code":"840"}];
      
    // }

    if (!this.dataService.getToken()) {
      this.router.navigateByUrl('/login');
    }
  } 
}

getCountryFlag(country:string){
  return "assets/img/"+country+".svg";
}

processBusniessList(data: any) {
   
  this.businesCodeMap = data['data'];
  
  for (const [key, value] of Object.entries(this.businesCodeMap)) { 
   if( key=="356"){
     console.log("356")
       this.businessList = value;
       for (var i=0; i < this.businessList.length ; ++i){
         this.businessNameList.push(this.businessList[i]['businessDisplayName']);
       
       }
       this.businessNameListOnUIIndia = this.businessNameList;
       this.businessNameListOnUI['India'] = this.businessNameListOnUIIndia;
       this.businessNameList=[];

   }
    if(key=="784"){
     console.log("784")

     this.businessList = value;
     for (var i=0; i < this.businessList.length ; ++i){
       this.businessNameList.push(this.businessList[i]['businessDisplayName']);
     
     }
     this.businessNameListOnUIUAE= this.businessNameList;
     this.businessNameListOnUI['Uae'] = this.businessNameListOnUIUAE;

     this.businessNameList=[];


 }
 if( key=="840"){
  
   this.businessList = value;
   for (var i=0; i < this.businessList.length ; ++i){
     this.businessNameList.push(this.businessList[i]['businessDisplayName']);
   
   }
   this.businessNameListOnUIUSA= this.businessNameList;
   this.businessNameListOnUI['Usa'] = this.businessNameListOnUIUSA;

   this.businessNameList=[];
  console.log("840");

}
}

// this.businessNameListOnUI = this.businessNameList;
this.businessNameList=[];
this.dataService.offSpinner();

}

getBusinessNameListForCountry(countryName: string): string[] {
  const businessNameList = this.businessNameListOnUI[countryName] || [];
  return businessNameList;
}

}